var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 38,
    height: 38,
    rx: 3,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 38,
    height: 38,
    rx: 3,
    stroke: "#E5E5E5",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1922_5266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 20C11 19.8011 11.079 19.6103 11.2197 19.4697C11.3603 19.329 11.5511 19.25 11.75 19.25H26.45C26.6489 19.25 26.8397 19.329 26.9803 19.4697C27.121 19.6103 27.2 19.8011 27.2 20C27.2 20.1989 27.121 20.3897 26.9803 20.5303C26.8397 20.671 26.6489 20.75 26.45 20.75H11.75C11.5511 20.75 11.3603 20.671 11.2197 20.5303C11.079 20.3897 11 20.1989 11 20ZM21.5 25.25H11.75C11.5511 25.25 11.3603 25.329 11.2197 25.4697C11.079 25.6103 11 25.8011 11 26C11 26.1989 11.079 26.3897 11.2197 26.5303C11.3603 26.671 11.5511 26.75 11.75 26.75H21.5C21.6989 26.75 21.8897 26.671 22.0303 26.5303C22.171 26.3897 22.25 26.1989 22.25 26C22.25 25.8011 22.171 25.6103 22.0303 25.4697C21.8897 25.329 21.6989 25.25 21.5 25.25ZM11.75 14.75H28.25C28.4489 14.75 28.6397 14.671 28.7803 14.5303C28.921 14.3897 29 14.1989 29 14C29 13.8011 28.921 13.6103 28.7803 13.4697C28.6397 13.329 28.4489 13.25 28.25 13.25H11.75C11.5511 13.25 11.3603 13.329 11.2197 13.4697C11.079 13.6103 11 13.8011 11 14C11 14.1989 11.079 14.3897 11.2197 14.5303C11.3603 14.671 11.5511 14.75 11.75 14.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 26C32 26.0884 31.9649 26.1732 31.9024 26.2357C31.8399 26.2982 31.7551 26.3333 31.6667 26.3333H28.3333V29.6667C28.3333 29.7551 28.2982 29.8399 28.2357 29.9024C28.1732 29.9649 28.0884 30 28 30C27.9116 30 27.8268 29.9649 27.7643 29.9024C27.7018 29.8399 27.6667 29.7551 27.6667 29.6667V26.3333H24.3333C24.2449 26.3333 24.1601 26.2982 24.0976 26.2357C24.0351 26.1732 24 26.0884 24 26C24 25.9116 24.0351 25.8268 24.0976 25.7643C24.1601 25.7018 24.2449 25.6667 24.3333 25.6667H27.6667V22.3333C27.6667 22.2449 27.7018 22.1601 27.7643 22.0976C27.8268 22.0351 27.9116 22 28 22C28.0884 22 28.1732 22.0351 28.2357 22.0976C28.2982 22.1601 28.3333 22.2449 28.3333 22.3333V25.6667H31.6667C31.7551 25.6667 31.8399 25.7018 31.9024 25.7643C31.9649 25.8268 32 25.9116 32 26Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1922_5266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 -1 32 32)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIcon);
export default __webpack_public_path__ + "static/media/drag-icon.cded00020ee077c953da9e367fba5437.svg";
export { ForwardRef as ReactComponent };